import angular from 'angular';
import { changePageTitle } from 'auth/actions/session.actions';
import BigWinnersWidgetComponent from './big-winners-widget-component';
import BigWinnersHistoryComponent from './components/big-winners-history-component';

export default angular
  .module('big-winners-widget', [])
  .component('bigWinnersWidget', new BigWinnersWidgetComponent())
  .component('bigWinnersHistory', new BigWinnersHistoryComponent())
  .config([
    '$stateProvider',
    function configuration($stateProvider) {
      $stateProvider.state('bigWinners-history', {
        parent: 'arw',
        url: '/big-winners/history/:retailerNo?isDisabledShare',
        template: '<big-winners-history></big-winners-history>',
        redirectTo: 'permissions-denied',
        params: {
          pageTitle: [
            '$ngRedux',
            'gettextCatalog',
            ($ngRedux, gettextCatalog) => {
              $ngRedux.dispatch(changePageTitle(gettextCatalog.getString('Historical Winners')));
            },
          ],
        },
      });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/big-winners/big-winners-widget-module.js